import React from 'react';

import {
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField
} from '@mui/material';

import {
  KeyboardArrowDown,
  SearchOutlined
} from '@mui/icons-material';

import CardContentWrapper from './CardContentWrapper';

import CommonTable
  from '../../Common/components/Listing/CommonTable';

import {
  menuProps,
  searchFieldSx,
  textFieldSx
} from '../../Common/components/Styles/InputStyles';

import {
  patientColumns
} from '../settingsConfig';

const PatientSettings = ({
  search,
  status,
  rows,
  totalCount,
  page,
  rowsPerPage,
  onSearchChange,
  onStatusChange,
  onPageChange,
  onRowsPerPageChange,
  onInvite,
  renderAction
}) => {
  return (
    <CardContentWrapper
      title="View/Manage Patients"
      count={`${totalCount} Patients`}
      buttonText="Invite Patient"
      onInvite={onInvite}>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          mb: 1.5,
          flexWrap: 'wrap'
        }}>
        <TextField
          size="small"
          value={search}
          placeholder="Search patients..."
          onChange={onSearchChange}
          sx={{
            ...searchFieldSx,
            width: '25%'
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined
                    sx={{
                      color: '#9E9E9E',
                      fontSize: 20
                    }}
                  />
                </InputAdornment>
              )
            }
          }}
        />

        <FormControl
          size="small"
          sx={{
            ...textFieldSx,
            width: '21%'
          }}>
          <Select
            size="small"
            value={status}
            onChange={onStatusChange}
            IconComponent={KeyboardArrowDown}
            MenuProps={menuProps}>
            <MenuItem value="All">
              All Status
            </MenuItem>

            <MenuItem value="Active">
              Active
            </MenuItem>

            <MenuItem value="Inactive">
              Inactive
            </MenuItem>
          </Select>
        </FormControl>
      </Stack>

      <CommonTable
        columns={patientColumns}
        rows={rows}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[
          25,
          50,
          75,
          100
        ]}
        emptyText="No patient records found."
        onPageChange={onPageChange}
        onRowsPerPageChange={
          onRowsPerPageChange
        }
        renderAction={renderAction}
        actionWrapper={false}
      />
    </CardContentWrapper>
  );
};

export default PatientSettings;